<template>
  <li class="icon-list-item list-none flex items-center py-1">
    <div class="pr-1">
      <i
        :class="{
          'iconify svg--account': icon === 'account',
          'iconify svg--arrivals': icon === 'arrivals',
          'iconify svg--bell': icon === 'bell',
          'iconify svg--order': icon === 'order',
          'iconify svg--invoice': icon === 'invoice',
          'iconify svg--recommendations': icon === 'recommendations',
          'iconify svg--faster_checkout': icon === 'faster_checkout',
          'iconify svg--checkmark': icon === 'checkmark',
          'iconify svg--checkmark-circle': icon === 'checkmark-circle',
          'iconify svg--chevron-right': icon === 'chevron',
          'iconify svg--circle-full': icon === 'circle',
          'iconify svg--dollar-down': icon === 'dollar-down',
          'iconify svg--download': icon === 'download',
          'iconify svg--expondo': icon === 'expondo',
          'iconify svg--heart': icon === 'heart',
          'iconify svg--info': icon === 'info',
          'iconify svg--secure-payment': icon === 'payment',
          'iconify svg--ribbon': icon === 'ribbon',
          'iconify svg--sale': icon === 'sale',
          'iconify svg--shopping-bag': icon === 'shopping-bag',
          'iconify svg--star-filled': icon === 'star',
          'iconify svg--truck': icon === 'truck',
          [iconColor]: iconColor,
        }"
      />
    </div>
    <div class="iconic-list-item__caption">
      <CustomLink
        v-if="url"
        :text="text"
        :url="url"
        :type="LINK_TYPE.NoUnderline"
      />
      <span
        v-else
      >
        {{ text }}
      </span>
    </div>
  </li>
</template>

<script lang="ts">

import { ListItemIcon, LIST_ITEM_ICON_COLOR_VALUES } from './IconicListItemTypes';
import { LINK_TYPE } from '~~/types/components/Link/LinkType';

export default defineComponent({
  name: 'IconicListItem',

  props: {
    icon: {
      type: String,
      default: ListItemIcon.star,
    },
    iconColor: {
      type: String,
      default: LIST_ITEM_ICON_COLOR_VALUES.blue,
    },
    text: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      default: null,
    },
  },
  setup() {

    return {
      LINK_TYPE,
    };
  
  },
});

</script>

<style lang="scss" scoped>
  .icon-list-item {
    i {
      @apply text-3xl relative;

      top: 7px;
    }
  }
</style>
